import { DragonBonesBaseController, IDragonBonesControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { PlayerModel } from "../../Models/PlayerModel";

export class PlayerDragonBonesController extends DragonBonesBaseController {
    $model: PlayerModel;

    public constructor(@Inject private _options) {
        super("MaleDragonBonesController");
    }

    public getConfiguration(): IDragonBonesControllerConfiguration {
        return {
            armatureName: this._options.name,
            childControllers: {},
            animations: {
                idle: "idle",
                step_left: "step_left",
                step_right: "step_right",
                swing: "swing",
                throw: "throw",
            }
        };
    }

    public onInitialize(): void {
        this.idle();
        this.scaleX = 0.33;
        this.scaleY = 0.33;
    }


    idle() {
        this.$animations.get("idle").play(-1);
    };

    moveRight() {
        this.$animations.get("step_right").play(-1);
    };

    moveLeft() {
        this.$animations.get("step_left").play(-1);
    };

    throw() {
        this.$animations.get("throw").play(1);
    };

    swing() {
        this.$animations.get("swing").play(1);
    };



}